import { render, staticRenderFns } from "./SelectStudiengang.vue?vue&type=template&id=6f2ac799"
import script from "./SelectStudiengang.vue?vue&type=script&lang=js"
export * from "./SelectStudiengang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports